import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import { MSpinner, MCollapsibleCard } from "components/Shared";
import { dateToString } from "components/Shared/Formatters";

const GaarResults = ({ gaarResults, fetchingGaarResults, getControlMethods }) => {
  const [expanded, setExpanded] = useState(gaarResults && Object.keys(gaarResults).length ? true : false);
  const [currentResults, setCurrentResults] = useState(gaarResults);
  const ref = useRef();
  const mounted = useRef(true);

  useEffect(() => {
    return () => { mounted.current = false; };
  }, []);

  useEffect(() => {
    if (gaarResults && Object.keys(gaarResults).length && resultsAreNew(gaarResults)) {
      updateResults(gaarResults);
    }
  }, [gaarResults]);

  const resultsAreNew = (newResults) => {
    if (!currentResults || !Object.keys(currentResults).length) { return true; }
    const differentLength = newResults.ruleFirings?.length !== currentResults.ruleFirings?.length;
    if (differentLength) { return true; }
    const currentIds = currentResults.ruleFirings?.map(r => r.id);
    const differentIds = newResults.ruleFirings?.filter(r => !currentIds?.includes(r.id));
    if (differentIds?.length) { return true; }
    return false;
  };

  const updateResults = (newResults) => {
    setCurrentResults(newResults);
    if (!expanded) { setExpanded(true); }
  };
  
  const openCard = () => setExpanded(true);

  if (getControlMethods) getControlMethods({ ref: ref, openCard: openCard });

  if (fetchingGaarResults) return <MSpinner />;

  const showResults = currentResults?.ruleFirings?.length > 0;

  return (
    <div ref={ref}>
      <MCollapsibleCard
        title="GAAR Results"
        expanded={expanded}
        onExpandedChange={setExpanded}
        styledHeader={false}
      >
        {showResults &&
        <TableContainer component="div" className="md-cell--12">
          <Table>
          <TableHead>
            <TableRow>
              <TableCell>Message</TableCell>
              <TableCell>Reviewed By</TableCell>
              <TableCell>Reviewed Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {gaarResults.ruleFirings.map(
              ({ id, ruleMessage, reviewedByInternetUser, reviewedOnUtc }) => (
                <TableRow key={id}>
                  {/* eslint-disable-next-line react/no-danger */}
                  <TableCell><div dangerouslySetInnerHTML={{ __html: ruleMessage }} /></TableCell>
                  <TableCell>{reviewedByInternetUser?.fullName}</TableCell>
                  <TableCell>{dateToString(reviewedOnUtc)}</TableCell>
                </TableRow>
              ))}
          </TableBody>
          </Table>
        </TableContainer>}
        {!showResults && gaarResults &&
          <div className="md-cell--12">No GAAR rules triggered.</div>}
        {!gaarResults &&
          <div className="md-cell--12">No GAAR results.</div>}
      </MCollapsibleCard>
    </div>
  );
};

GaarResults.propTypes = {
  gaarResults: PropTypes.object,
  fetchingGaarResults: PropTypes.bool,
  getControlMethods: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    gaarResults: state.validation.gaarResults,
    fetchingGaarResults: state.validation.fetchingGaarResults,
  };
};

export default connect(mapStateToProps)(GaarResults);